// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3sTSw","rootCenter":"LoadMoreObserver_rootCenter__3edCF","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__4uR5O"};